__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__GhtaUW__checkbox",
  "checkbox-box": "checkbox-module-scss-module__GhtaUW__checkbox-box",
  "checkbox-icon": "checkbox-module-scss-module__GhtaUW__checkbox-icon",
  "checkbox-indeterminate-icon": "checkbox-module-scss-module__GhtaUW__checkbox-indeterminate-icon",
  "checkbox-input": "checkbox-module-scss-module__GhtaUW__checkbox-input",
  "checkbox-label": "checkbox-module-scss-module__GhtaUW__checkbox-label",
  "checkbox-outline-icon": "checkbox-module-scss-module__GhtaUW__checkbox-outline-icon",
  "checkbox-ripple": "checkbox-module-scss-module__GhtaUW__checkbox-ripple",
  "disabled": "checkbox-module-scss-module__GhtaUW__disabled",
  "error": "checkbox-module-scss-module__GhtaUW__error",
  "helper-text": "checkbox-module-scss-module__GhtaUW__helper-text",
  "icon": "checkbox-module-scss-module__GhtaUW__icon",
  "secondary": "checkbox-module-scss-module__GhtaUW__secondary",
});
